<template>
  <v-row align="center">
    <v-overlay :value="loading || statisticsLoading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>  

    <div class="col-md-12">   
        <ProjectGrid></ProjectGrid>
    </div>
    <div class="col-md-12 home-tabs-body">
     
    </div>
  </v-row>
</template>

<script>

import ProjectGrid from "@/components/review-projects/view/ProjectGrid";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Projects",
  components: {
    ProjectGrid
  },
  data: function() {
    return {
      statistics: [],
      statisticsLoading: false,
      statsNotFound: require("@/assets/img/stats_empty.png")
    };
  },
  computed: {
    ...mapGetters({     
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");  
  },

  watch: {
   
  },

  methods: {
   
    },   
  
};
</script>
